export default {"src":"/_next/static/media/clock.670c6406.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};